import React from "react";

import useTenantOptions from "../../hooks/useTenantOptions";

import styles from "./TenantInfoBanner.module.scss";

interface TenantInfoBannerProps {
  className?: string;
}

const TenantInfoBanner: React.FC<TenantInfoBannerProps> = ({ className }) => {
  const [ tenantOptions ] = useTenantOptions();

  if (!tenantOptions) {
    return null;
  }

  return (
    <div className={`${styles.tenantBanner} ${className || ""}`}>
      <span className={styles.value}>{tenantOptions?.tenantFullName}</span>
    </div>
  );
};

export default TenantInfoBanner;
